import * as types from './mutation-type';
import { listType } from '../common/js/config';
import { concat, slice, findIndex } from 'lodash';

export const setList = function({ commit, state }, { list, type }) {
  switch (type) {
    case listType.COURSE:
      let courseList = slice(state.courseList);
      courseList = list;
      commit(types.SET_COURSE_LIST, courseList);
      break;
    case listType.ACTIVITY:
      let activityList = slice(state.activityList);
      activityList = list;
      commit(types.SET_ACTIVITY_LIST, activityList);
      break;
    case listType.ACTIVITY_COURSE:
      let activityCourseList = slice(state.activityCourseList);
      activityCourseList = list;
      commit(types.SET_ACTIVITY_COURSE_LIST, activityCourseList);
      break;
    case listType.SCHOOL:
      let schoolList = slice(state.schoolList);
      schoolList = list;
      commit(types.SET_SCHOOL_LIST, schoolList);
      break;
    case listType.COACH:
      let coachList = slice(state.coachList);
      coachList = list;
      commit(types.SET_COACH_LIST, coachList);
      break;
    case listType.ORDER:
      let orderList = slice(state.coachList);
      orderList = list;
      commit(types.SET_ORDER_LIST, orderList);
      break;
    case listType.UPLOAD_COACH:
      let uploadCoachList = slice(state.uploadCoachList);
      uploadCoachList = list;
      commit(types.SET_UPLOAD_COACH_LIST, uploadCoachList);
      break;
    case listType.STOCK:
      let stockList = slice(state.stockList);
      stockList = list;
      commit(types.SET_STOCK_LIST, stockList);
      break;
    case listType.STUDENT:
      let studentList = slice(state.studentList);
      studentList = list;
      commit(types.SET_STUDENT_LIST, studentList);
      break;
    case listType.CERT:
      let certList = slice(state.certList);
      certList = list;
      commit(types.SET_CERT_LIST, certList);
      break;
  }
};

export const insertList = function({ commit, state }, { list, type }) {
  switch (type) {
    case listType.ACTIVITY_COURSE:
      let activityCourseList = slice(state.activityCourseList);
      activityCourseList = concat(list, activityCourseList);
      commit(types.SET_ACTIVITY_COURSE_LIST, activityCourseList);
      break;
    case listType.COACH:
      let coachList = state.coachList.slice();
      coachList = concat(list, coachList);
      commit(types.SET_COACH_LIST, coachList);
      break;
  }
};

export const insertItem = function({ commit, state }, { item, type }) {
  switch (type) {
    case listType.COURSE:
      let courseList = state.courseList.slice();
      courseList = [item, ...courseList];
      commit(types.SET_COURSE_LIST, courseList);
      break;
    case listType.ACTIVITY:
      let activityList = state.activityList.slice();
      activityList = [item, ...activityList];
      commit(types.SET_ACTIVITY_LIST, activityList);
      break;
    case listType.SCHOOL:
      let schoolList = state.schoolList.slice();
      schoolList = [item, ...schoolList];
      commit(types.SET_SCHOOL_LIST, schoolList);
      break;
    case listType.COACH:
      let coachList = state.coachList.slice();
      coachList = [item, ...coachList];
      commit(types.SET_COACH_LIST, coachList);
      break;
    case listType.UPLOAD_COACH:
      let uploadCoachList = state.uploadCoachList.slice();
      uploadCoachList = [item, ...uploadCoachList];
      commit(types.SET_UPLOAD_COACH_LIST, uploadCoachList);
      break;
  }
};

export const setItem = function({ commit, state }, { item, type }) {
  switch (type) {
    case listType.COURSE:
      commit(types.SET_COURSE, item);
      break;
    case listType.SCHOOL:
      commit(types.SET_SCHOOL, item);
      break;
    case listType.COACH:
      commit(types.SET_COACH, item);
      break;
    case listType.CERT:
      commit(types.SET_CERT, item);
      break;
  }
};

export const updateItem = function({ commit, state }, { item, type }) {
  switch (type) {
    case listType.COURSE:
      let courseList = slice(state.courseList);
      let courseIndex = _findIndex(courseList, item);
      courseList[courseIndex] = Object.assign({}, courseList[courseIndex], item);
      commit(types.SET_COURSE_LIST, courseList);
      break;
    case listType.ACTIVITY:
      let activityList = slice(state.activityList);
      let activityIndex = _findIndex(activityList, item);
      activityList[activityIndex] = Object.assign({}, activityList[activityIndex], item);
      commit(types.SET_COURSE_LIST, activityList);
      break;
    case listType.SCHOOL:
      let schoolList = slice(state.schoolList);
      let schoolIndex = _findIndex(schoolList, item);
      schoolList[schoolIndex] = Object.assign({}, schoolList[schoolIndex], item);
      commit(types.SET_SCHOOL_LIST, schoolList);
      break;
    case listType.COACH:
      let coachList = slice(state.coachList);
      let coachIndex = _findIndex(coachList, item);
      coachList[coachIndex] = Object.assign({}, coachList[coachIndex], item);
      commit(types.SET_COURSE_LIST, coachList);
      break;
  }
};

export const deleteItem = function({ commit, state }, { item, type }) {
  switch (type) {
    case listType.COURSE:
      let courseList = slice(state.courseList);
      let courseIndex = _findIndex(courseList, item);
      courseList.splice(courseIndex, 1);
      commit(types.SET_COURSE_LIST, courseList);
      break;
    case listType.ACTIVITY:
      let activityList = slice(state.activityList);
      let activityIndex = _findIndex(activityList, item);
      activityList.splice(activityIndex, 1);
      commit(types.SET_ACTIVITY_LIST, activityList);
      break;
    case listType.SCHOOL:
      let schoolList = slice(state.schoolList);
      let schoolIndex = _findIndex(schoolList, item);
      schoolList.splice(schoolIndex, 1);
      commit(types.SET_SCHOOL_LIST, schoolList);
      break;
    case listType.COACH:
      let coachList = slice(state.coachList);
      let coachIndex = _findIndex(schoolList, item);
      coachList.splice(coachIndex, 1);
      commit(types.SET_COURSE_LIST, coachList);
      break;
  }
};

export const deleteItems = function({ commit, state }, { items, type }) {
  switch (type) {
    case listType.ACTIVITY_COURSE:
      let activityCourseList = slice(state.activityCourseList);
      for (let i = 0; i < items.length; i++) {
        let courseIndex = findIndex(activityCourseList, (item) => {
          return item.courseUuid === items[i].courseUuid;
        });
        activityCourseList.splice(courseIndex, 1);
      }
      commit(types.SET_ACTIVITY_COURSE_LIST, activityCourseList);
      break;
  }
};


function _findIndex(list, _item) {
  return findIndex(list, (item) => {
    return item.uuid === _item.uuid;
  });
}